import { TopicKey } from "@hub/data/values/data-keys.enum";
import { LabCardData } from "@hub/models/document/document-card-data";
import React from "react";
import { AnchorLink } from "../anchor-link";
import { BracketsIcon } from "../icons/brackets-icon";
import { DocumentCardHeadline } from "./document-card-headline";
import { DocumentCardIcon } from "./document-card-icon";
import styles from "./document-card.module.css";

interface LabCardProps {
  data: LabCardData;
  openNewTab?: boolean;
  testName?: string;
  withTopBorder?: boolean;
}

export const LabCard: React.FC<LabCardProps> = ({
  data,
  openNewTab,
  testName,
  withTopBorder = false,
}) => {
  const { title, description, icons, path, topic } = data;

  icons.secondary.src = "/resources/logos/lock-logo.svg";

  switch (topic) {
    case TopicKey.AUTHENTICATION:
    case TopicKey.AUTHORIZATION: {
      icons.secondary.src = "/resources/logos/lock-logo.svg";

      break;
    }
    case TopicKey.ACTIONS: {
      icons.secondary.src = "/resources/logos/customize-logo.svg";

      break;
    }

    case TopicKey.TOOLS: {
      icons.secondary.src = "/resources/logos/tools-logo.svg";

      break;
    }
    case TopicKey.AUTH0_FORMS: {
      icons.secondary.src = "/resources/logos/forms-logo.svg";

      break;
    }
  }

  return (
    <AnchorLink
      testName={testName}
      to={path}
      openNewTab={openNewTab ? openNewTab : data.newTab ? data.newTab : false}
      className={`${styles.documentCard}${
        withTopBorder ? ` ${styles.documentCard_withTopBorder}` : ""
      }`}
    >
      <div className={styles.mediaBar}>
        <div className={styles.mediaBar__icons}>
          <DocumentCardIcon src={icons.primary.src} alt={icons.primary.alt} />
          <DocumentCardIcon
            src={icons.secondary.src}
            alt={icons.secondary.alt}
          />
        </div>
      </div>
      <DocumentCardHeadline title={title} description={description} />
      <div className={styles.documentCard__button}>
        <BracketsIcon />
      </div>
    </AnchorLink>
  );
};
